import vPreventAndroidScrollMixin from '@/mixin/directives/v-preventAndroidScroll';
export default {
  mixins: [vPreventAndroidScrollMixin]
};